import React, { useState } from 'react';
import { Modal, Button, Upload, Table, Alert, Progress, Space, Typography, Tag, Card, message } from 'antd';
import { UploadOutlined, DownloadOutlined, FileExcelOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import * as Excel from 'exceljs';
import { saveAs } from 'file-saver';
import treeData from '../../Item/treeView.json';
import firebase from '../../../firebase';

const { Text, Title, Paragraph } = Typography;

const specColumns = [];
for (let i = 1; i <= 20; i++) {
    specColumns.push({ key: `表題${i}`, label: `表題${i}`, required: false, type: 'string' });
    specColumns.push({ key: `値${i}`, label: `値${i}`, required: false, type: 'string' });
}

const docColumns = [
    { key: 'SDS１ボタン名', label: 'SDS１ボタン名', required: false, type: 'string' },
    { key: 'SDS１ファイル名', label: 'SDS１ファイル名', required: false, type: 'string' },
    { key: 'SDS１タイトル', label: 'SDS１タイトル', required: false, type: 'string' },
    { key: 'SDS１ふりがな', label: 'SDS１ふりがな', required: false, type: 'string' },
    { key: 'SDS１発行年月日', label: 'SDS１発行年月日', required: false, type: 'date' },
    { key: '取説１ボタン名', label: '取説１ボタン名', required: false, type: 'string' },
    { key: '取説１ファイル名', label: '取説１ファイル名', required: false, type: 'string' },
    { key: '取説１タイトル', label: '取説１タイトル', required: false, type: 'string' },
    { key: '取説１ふりがな', label: '取説１ふりがな', required: false, type: 'string' },
    { key: '取説１発行年月日', label: '取説１発行年月日', required: false, type: 'date' },
    { key: '取説２ボタン名', label: '取説２ボタン名', required: false, type: 'string' },
    { key: '取説２ファイル名', label: '取説２ファイル名', required: false, type: 'string' },
    { key: '取説２タイトル', label: '取説２タイトル', required: false, type: 'string' },
    { key: '取説２ふりがな', label: '取説２ふりがな', required: false, type: 'string' },
    { key: '取説２発行年月日', label: '取説２発行年月日', required: false, type: 'date' },
    { key: 'カタログ１ボタン名', label: 'カタログ１ボタン名', required: false, type: 'string' },
    { key: 'カタログ１ファイル名', label: 'カタログ１ファイル名', required: false, type: 'string' },
    { key: 'カタログ１タイトル', label: 'カタログ１タイトル', required: false, type: 'string' },
    { key: 'カタログ１ふりがな', label: 'カタログ１ふりがな', required: false, type: 'string' },
    { key: 'カタログ１発行年月日', label: 'カタログ１発行年月日', required: false, type: 'date' },
    { key: 'カタログ２ボタン名', label: 'カタログ２ボタン名', required: false, type: 'string' },
    { key: 'カタログ２ファイル名', label: 'カタログ２ファイル名', required: false, type: 'string' },
    { key: 'カタログ２タイトル', label: 'カタログ２タイトル', required: false, type: 'string' },
    { key: 'カタログ２ふりがな', label: 'カタログ２ふりがな', required: false, type: 'string' },
    { key: 'カタログ２発行年月日', label: 'カタログ２発行年月日', required: false, type: 'date' },
    { key: 'カタログ３ボタン名', label: 'カタログ３ボタン名', required: false, type: 'string' },
    { key: 'カタログ３ファイル名', label: 'カタログ３ファイル名', required: false, type: 'string' },
    { key: 'カタログ３タイトル', label: 'カタログ３タイトル', required: false, type: 'string' },
    { key: 'カタログ３ふりがな', label: 'カタログ３ふりがな', required: false, type: 'string' },
    { key: 'カタログ３発行年月日', label: 'カタログ３発行年月日', required: false, type: 'date' },
    { key: '図面１ボタン名', label: '図面１ボタン名', required: false, type: 'string' },
    { key: '図面１ファイル名', label: '図面１ファイル名', required: false, type: 'string' },
    { key: '図面１タイトル', label: '図面１タイトル', required: false, type: 'string' },
    { key: '図面１ふりがな', label: '図面１ふりがな', required: false, type: 'string' },
    { key: '図面１発行年月日', label: '図面１発行年月日', required: false, type: 'date' },
    { key: '図面２ボタン名', label: '図面２ボタン名', required: false, type: 'string' },
    { key: '図面２ファイル名', label: '図面２ファイル名', required: false, type: 'string' },
    { key: '図面２タイトル', label: '図面２タイトル', required: false, type: 'string' },
    { key: '図面２ふりがな', label: '図面２ふりがな', required: false, type: 'string' },
    { key: '図面２発行年月日', label: '図面２発行年月日', required: false, type: 'date' },
    { key: '図面３ボタン名', label: '図面３ボタン名', required: false, type: 'string' },
    { key: '図面３ファイル名', label: '図面３ファイル名', required: false, type: 'string' },
    { key: '図面３タイトル', label: '図面３タイトル', required: false, type: 'string' },
    { key: '図面３ふりがな', label: '図面３ふりがな', required: false, type: 'string' },
    { key: '図面３発行年月日', label: '図面３発行年月日', required: false, type: 'date' },
];

const imageColumns = [
    { key: '画像１ファイル名', label: '画像１ファイル名', required: false, type: 'string' },
    { key: '画像１タイトル', label: '画像１タイトル', required: false, type: 'string' },
    { key: '画像１ふりがな', label: '画像１ふりがな', required: false, type: 'string' },
    { key: '画像１表示順', label: '画像１表示順', required: false, type: 'number' },
    { key: '画像２ファイル名', label: '画像２ファイル名', required: false, type: 'string' },
    { key: '画像２タイトル', label: '画像２タイトル', required: false, type: 'string' },
    { key: '画像２ふりがな', label: '画像２ふりがな', required: false, type: 'string' },
    { key: '画像２表示順', label: '画像２表示順', required: false, type: 'number' },
    { key: '画像３ファイル名', label: '画像３ファイル名', required: false, type: 'string' },
    { key: '画像３タイトル', label: '画像３タイトル', required: false, type: 'string' },
    { key: '画像３ふりがな', label: '画像３ふりがな', required: false, type: 'string' },
    { key: '画像３表示順', label: '画像３表示順', required: false, type: 'number' },
];

const metaSystemColumns = [
    { key: '一般公開可否', label: '一般公開可否', required: false, type: 'string' },
    { key: '新規登録依頼日', label: '新規登録依頼日', required: false, type: 'date' },
    { key: '変更申請依頼日', label: '変更申請依頼日', required: false, type: 'date' },
    { key: '販売M企業名', label: '販売M企業名', required: false, type: 'string' },
    { key: '販売M事業所名', label: '販売M事業所名', required: false, type: 'string' },
    { key: '販売M申請者', label: '販売M申請者', required: false, type: 'string' },
    { key: 'P4CLOUD登録日', label: 'P4CLOUD登録日', required: false, type: 'date' },
    { key: 'P4CLOUD登録者', label: 'P4CLOUD登録者', required: false, type: 'string' },
];

const COLUMNS = [
    { key: 'No', label: 'NO.', required: true, type: 'number' },
    { key: '仕入先（本社）', label: '仕入先（本社）', required: true, type: 'string' },
    { key: '仕入先法人番号', label: '仕入先法人番号', required: false, type: 'corporate_number' },
    { key: '仕入先事業所名', label: '仕入先事業所名', required: true, type: 'string' },
    { key: '仕入先事業所コード', label: '仕入先事業所コード', required: false, type: 'string' },
    { key: 'P4CLOUD仕入先コード', label: 'P4CLOUD仕入先コード', required: false, type: 'string' },
    { key: '仕入先EDIコード商品コード', label: '仕入先EDIコード商品コード', required: false, type: 'string' },
    { key: '仕入先発注コード', label: '仕入先発注コード', required: false, type: 'string' },
    { key: '正式メーカー名', label: '正式メーカー名', required: true, type: 'string' },
    { key: 'メーカー法人番号', label: 'メーカー法人番号', required: false, type: 'corporate_number' },
    { key: '販売企業商品コード', label: '販売企業商品コード', required: false, type: 'string' },
    { key: '正式メーカー商品名', label: '正式メーカー商品名', required: true, type: 'string' },
    { key: '正式メーカー商品名かな', label: '正式メーカー商品名かな', required: false, type: 'string' },
    { key: 'P4CLOUD商品コード', label: 'P4CLOUD商品コード', required: false, type: 'string' },
    { key: 'P4CLOUD商品名', label: 'P4CLOUD商品名', required: true, type: 'string' },
    { key: 'P4CLOUD商品名ふりがな', label: 'P4CLOUD商品名ふりがな', required: false, type: 'string' },
    { key: '容量・入数', label: '容量・入数', required: true, type: 'string' },
    { key: '発注数量', label: '発注数量', required: true, type: 'number' },
    { key: '単位', label: '単位', required: true, type: 'string' },
    { key: '発注数', label: '発注数', required: true, type: 'number' },
    { key: '発注単位', label: '発注単位', required: true, type: 'string' },
    { key: '荷姿名称１', label: '荷姿名称１', required: true, type: 'string' },
    { key: '劇毒物区分名', label: '劇毒物区分名', required: false, type: 'string' },
    { key: '危険物区分名', label: '危険物区分名', required: false, type: 'string' },
    { key: '消費税率', label: '消費税率', required: true, type: 'tax_rate' },
    { key: '大分類', label: '大分類', required: true, type: 'category_major' },
    { key: '中分類', label: '中分類', required: true, type: 'category_middle' },
    { key: '小分類', label: '小分類', required: true, type: 'category_small' },
    { key: '売価', label: '売価', required: true, type: 'number' },
    { key: 'expirationDate', label: '価格有効期限', required: false, type: 'date' },
    ...specColumns,
    ...docColumns,
    ...imageColumns,
    ...metaSystemColumns
];

const getCellValue = (cell) => {
    if (!cell) return null;
    let val = cell.value;
    if (val === null || val === undefined) return null;
    if (typeof val === 'object') {
        if (val instanceof Date) {
            return val;
        }
        if (val.result !== undefined) {
            return val.result;
        }
        if (val.text !== undefined) {
            return val.text;
        }
        if (Array.isArray(val.richText)) {
            return val.richText.map(t => t.text).join('');
        }
    }
    return val;
};

const formatDateYYYYMMDD = (val) => {
    if (!val) return null;
    if (val instanceof Date && !isNaN(val.getTime())) {
        const y = val.getFullYear();
        const m = String(val.getMonth() + 1).padStart(2, '0');
        const d = String(val.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    }
    if (typeof val === 'string') {
        const trimmed = val.trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
        const d = new Date(trimmed);
        if (!isNaN(d.getTime())) {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        }
    }
    return val;
};

const toFirestoreTimestamp = (val) => {
    if (!val) return null;
    if (val instanceof firebase.firestore.Timestamp) return val;
    if (val instanceof Date) {
        return isNaN(val.getTime()) ? null : firebase.firestore.Timestamp.fromDate(val);
    }
    if (typeof val === 'string') {
        const trimmed = val.trim();
        const d = new Date(trimmed);
        if (!isNaN(d.getTime())) {
            return firebase.firestore.Timestamp.fromDate(d);
        }
    }
    return null;
};

const DOC_GROUPS = [
    { name: 'SDS1', prefix: 'sds', nameKey: 'SDS１ボタン名', fileKey: 'SDS１ファイル名', fields: ['SDS１ボタン名', 'SDS１ファイル名', 'SDS１タイトル', 'SDS１ふりがな', 'SDS１発行年月日'], isImage: false },
    { name: '取説1', prefix: 'manual', nameKey: '取説１ボタン名', fileKey: '取説１ファイル名', fields: ['取説１ボタン名', '取説１ファイル名', '取説１タイトル', '取説１ふりがな', '取説１発行年月日'], isImage: false },
    { name: '取説2', prefix: 'manual', nameKey: '取説２ボタン名', fileKey: '取説２ファイル名', fields: ['取説２ボタン名', '取説２ファイル名', '取説２タイトル', '取説２ふりがな', '取説２発行年月日'], isImage: false },
    { name: 'カタログ1', prefix: 'catalog', nameKey: 'カタログ１ボタン名', fileKey: 'カタログ１ファイル名', fields: ['カタログ１ボタン名', 'カタログ１ファイル名', 'カタログ１タイトル', 'カタログ１ふりがな', 'カタログ１発行年月日'], isImage: false },
    { name: 'カタログ2', prefix: 'catalog', nameKey: 'カタログ２ボタン名', fileKey: 'カタログ２ファイル名', fields: ['カタログ２ボタン名', 'カタログ２ファイル名', 'カタログ２タイトル', 'カタログ２ふりがな', 'カタログ２発行年月日'], isImage: false },
    { name: 'カタログ3', prefix: 'catalog', nameKey: 'カタログ３ボタン名', fileKey: 'カタログ３ファイル名', fields: ['カタログ３ボタン名', 'カタログ３ファイル名', 'カタログ３タイトル', 'カタログ３ふりがな', 'カタログ３発行年月日'], isImage: false },
    { name: '図面1', prefix: 'files', nameKey: '図面１ボタン名', fileKey: '図面１ファイル名', fields: ['図面１ボタン名', '図面１ファイル名', '図面１タイトル', '図面１ふりがな', '図面１発行年月日'], isImage: true },
    { name: '図面2', prefix: 'files', nameKey: '図面２ボタン名', fileKey: '図面２ファイル名', fields: ['図面２ボタン名', '図面２ファイル名', '図面２タイトル', '図面２ふりがな', '図面２発行年月日'], isImage: true },
    { name: '図面3', prefix: 'files', nameKey: '図面３ボタン名', fileKey: '図面３ファイル名', fields: ['図面３ボタン名', '図面３ファイル名', '図面３タイトル', '図面３ふりがな', '図面３発行年月日'], isImage: true },
];

const IMAGE_GROUPS = [
    { name: '画像1', dbKey: 'image', fileKey: '画像１ファイル名', fields: ['画像１ファイル名', '画像１タイトル', '画像１ふりがな', '画像１表示順'] },
    { name: '画像2', dbKey: 'image2', fileKey: '画像２ファイル名', fields: ['画像２ファイル名', '画像２タイトル', '画像２ふりがな', '画像２表示順'] },
    { name: '画像3', dbKey: 'image3', fileKey: '画像３ファイル名', fields: ['画像３ファイル名', '画像３タイトル', '画像３ふりがな', '画像３表示順'] },
];

const EXCLUDE_TOP_LEVEL_KEYS = new Set([
    'expirationDate',
    'priceAmount',
    ...specColumns.map(c => c.key),
]);

const getOrgName = (org) => {
    if (!org) return '';
    return org.display_name || org.name || org.organization_name || org.companyName || '';
};

const getOrgId = (org) => {
    if (!org) return '';
    return org.id || org.docId || '';
};

const ProductExcelImport = ({ getWriteRef, onSuccessRefresh, existingItems, sellerOrg, buyerOrg, orgSeller, org, user, userOrg }) => {
    const effectiveSellerOrg = sellerOrg || orgSeller || (user && !user.admin ? userOrg : null);
    const effectiveBuyerOrg = buyerOrg || org;

    const [modalOpen, setModalOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [attachedFileList, setAttachedFileList] = useState([]);
    const [requiredDocFiles, setRequiredDocFiles] = useState([]);
    const [rawExcelRows, setRawExcelRows] = useState([]);
    const [parsing, setParsing] = useState(false);
    const [importing, setImporting] = useState(false);
    const [progress, setProgress] = useState(0);
    const [parsedRows, setParsedRows] = useState([]);
    const [validationErrors, setValidationErrors] = useState([]);

    const validateParsedRows = (rawRowsList, currentAttachedList) => {
        const attachedNames = new Set();
        (currentAttachedList || []).forEach(f => {
            const raw = f.originFileObj || f;
            if (raw && raw.name) {
                const fullName = raw.name.trim().toLowerCase();
                const cleanName = fullName.split('/').pop().split('\\').pop().toLowerCase();
                attachedNames.add(fullName);
                attachedNames.add(cleanName);
            }
        });

        const tempParsed = [];
        const tempErrors = [];

        rawRowsList.forEach(item => {
            const { rowNumber, rowData, baseErrors } = item;
            const rowErrors = [...baseErrors];

            [...DOC_GROUPS, ...IMAGE_GROUPS].forEach(group => {
                const fileName = rowData[group.fileKey] ? String(rowData[group.fileKey]).trim() : '';
                if (fileName) {
                    const clean = fileName.split('/').pop().split('\\').pop().toLowerCase();
                    if (!attachedNames.has(clean)) {
                        rowErrors.push(`${group.fileKey}: 「${fileName}」ファイルが添付されていません。ステップ2から選択してください。`);
                    }
                }
            });

            if (rowErrors.length > 0) {
                tempErrors.push({
                    rowNumber,
                    productName: rowData['P4CLOUD商品名'] || '名称未設定の商品',
                    messages: rowErrors
                });
            } else {
                tempParsed.push({
                    rowNumber,
                    data: rowData
                });
            }
        });

        setParsedRows(tempParsed);
        setValidationErrors(tempErrors);
    };

    const handleAttachmentChange = (newFileList) => {
        setAttachedFileList(newFileList);
        if (rawExcelRows && rawExcelRows.length > 0) {
            validateParsedRows(rawExcelRows, newFileList);
        }
    };

    const downloadTemplate = async () => {
        try {
            const workbook = new Excel.Workbook();
            const worksheet = workbook.addWorksheet('商品登録テンプレート');

            const sellerName = getOrgName(effectiveSellerOrg);
            const sellerId = getOrgId(effectiveSellerOrg);
            const buyerName = getOrgName(effectiveBuyerOrg);
            const buyerId = getOrgId(effectiveBuyerOrg);

            // Row 1: Seller & Buyer Metadata (A1:H1)
            const metaRow = worksheet.getRow(1);
            metaRow.height = 35;

            metaRow.getCell(1).value = 'Seller Name*';
            metaRow.getCell(2).value = sellerName;
            metaRow.getCell(3).value = 'Seller ID*';
            metaRow.getCell(4).value = sellerId;
            metaRow.getCell(5).value = 'buyer Name*';
            metaRow.getCell(6).value = buyerName;
            metaRow.getCell(7).value = 'Buyer ID*';
            metaRow.getCell(8).value = buyerId;

            // Format Row 1 cells A1..H1 with bright yellow background
            for (let c = 1; c <= 8; c++) {
                const cell = metaRow.getCell(c);
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFF00' }
                };
                cell.font = {
                    name: 'Calibri',
                    size: 11,
                    bold: c % 2 !== 0
                };
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: c % 2 !== 0 ? 'center' : 'left',
                    wrapText: true
                };
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    left: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    bottom: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    right: { style: 'thin', color: { argb: 'FFD9D9D9' } }
                };
            }

            // Row 2: Columns and Headers setup
            const headerRow = worksheet.getRow(2);
            headerRow.height = 30;
            COLUMNS.forEach((col, idx) => {
                const cell = headerRow.getCell(idx + 1);
                cell.value = col.label + (col.required ? ' *' : '');
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF1890FF' } // Antd primary blue color
                };
                cell.font = {
                    color: { argb: 'FFFFFFFF' },
                    bold: true,
                    size: 11
                };
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                    wrapText: true
                };
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    left: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    bottom: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    right: { style: 'thin', color: { argb: 'FFD9D9D9' } }
                };
                worksheet.getColumn(idx + 1).width = 25;
            });

            // Row 3: Example Data Row
            const exampleData = {
                No: 1,
                '仕入先（本社）': '仕入先化学工業',
                仕入先法人番号: '9876543210987',
                仕入先事業所名: '東京営業所',
                仕入先事業所コード: 'TKY-01',
                P4CLOUD仕入先コード: 'P4SUP-001',
                仕入先EDIコード商品コード: 'EDI-999',
                仕入先発注コード: 'ORD-999',
                正式メーカー名: 'アサヒペン',
                メーカー法人番号: '1234567890123',
                販売企業商品コード: 'SEL-111',
                正式メーカー商品名: '水性アクリルペイント',
                正式メーカー商品名かな: 'すいせいあくりるぺいんと',
                P4CLOUD商品コード: 'P4PROD-001',
                P4CLOUD商品名: '水性アクリルペイント 16kg',
                P4CLOUD商品名ふりがな: 'すいせいあくりるぺいんと 16kg',
                '容量・入数': '16kg',
                発注数量: 16,
                単位: '缶',
                発注数: 1,
                発注単位: '1缶単位',
                荷姿名称１: '缶',
                劇毒物区分名: '該当外',
                危険物区分名: '該当外',
                消費税率: 0.1,
                大分類: 'A',
                中分類: '010',
                小分類: '020',
                売価: 20000,
                expirationDate: '2099-12-01',
                表題１: '色',
                値１: 'グレー',
                表題２: '容量',
                値２: '16Kg',
                一般公開可否: '可'
            };
            const dataRow = worksheet.getRow(3);
            COLUMNS.forEach((col, idx) => {
                dataRow.getCell(idx + 1).value = exampleData[col.key];
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const blob = new Blob([buffer], { type: fileType });
            saveAs(blob, 'P4CLOUD_Product_Import_Template.xlsx');
            message.success('テンプレートファイルをダウンロードしました。');
        } catch (err) {
            console.error('Download template error:', err);
            message.error('テンプレートファイルの生成中にエラーが発生しました。');
        }
    };

    const handleFileRead = async (file, fileListArg = []) => {
        setParsing(true);
        setValidationErrors([]);
        setParsedRows([]);

        const currentFileList = (fileListArg && fileListArg.length > 0) ? fileListArg : fileList;
        const uploadedFileNames = new Set();
        (currentFileList || []).forEach(f => {
            if (f && f.name) {
                uploadedFileNames.add(f.name.trim());
            }
            if (f && f.originFileObj && f.originFileObj.name) {
                uploadedFileNames.add(f.originFileObj.name.trim());
            }
        });

        let targetFile = file;
        const isExcel = (f) => f && f.name && (f.name.toLowerCase().endsWith('.xlsx') || f.name.toLowerCase().endsWith('.xls'));
        if (!isExcel(targetFile)) {
            targetFile = (currentFileList || []).find(isExcel);
        }

        if (!targetFile) {
            setValidationErrors([{ rowNumber: '-', productName: '-', messages: ['.xlsxまたは.xls形式のExcelファイルが選択されていません。'] }]);
            setParsing(false);
            return false;
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
            try {
                const buffer = e.target.result;
                const workbook = new Excel.Workbook();
                await workbook.xlsx.load(buffer);
                const worksheet = workbook.getWorksheet(1);

                if (!worksheet || worksheet.rowCount <= 2) {
                    setValidationErrors([{ rowNumber: '-', productName: '-', messages: ['ファイルにインポート可能な商品データが見つかりませんでした。'] }]);
                    setParsing(false);
                    return;
                }

                // Validate Row 1 (Seller/Buyer metadata A1:H1)
                const row1 = worksheet.getRow(1);
                const cellA1 = getCellValue(row1.getCell(1)) ? String(getCellValue(row1.getCell(1))).trim() : '';
                const cellB1 = getCellValue(row1.getCell(2)) ? String(getCellValue(row1.getCell(2))).trim() : '';
                const cellC1 = getCellValue(row1.getCell(3)) ? String(getCellValue(row1.getCell(3))).trim() : '';
                const cellD1 = getCellValue(row1.getCell(4)) ? String(getCellValue(row1.getCell(4))).trim() : '';
                const cellE1 = getCellValue(row1.getCell(5)) ? String(getCellValue(row1.getCell(5))).trim() : '';
                const cellF1 = getCellValue(row1.getCell(6)) ? String(getCellValue(row1.getCell(6))).trim() : '';
                const cellG1 = getCellValue(row1.getCell(7)) ? String(getCellValue(row1.getCell(7))).trim() : '';
                const cellH1 = getCellValue(row1.getCell(8)) ? String(getCellValue(row1.getCell(8))).trim() : '';

                const expectedSellerName = getOrgName(effectiveSellerOrg).trim();
                const expectedSellerId = getOrgId(effectiveSellerOrg).trim();
                const expectedBuyerName = getOrgName(effectiveBuyerOrg).trim();
                const expectedBuyerId = getOrgId(effectiveBuyerOrg).trim();

                const metaErrors = [];
                const hasA1Label = cellA1.toLowerCase().includes('seller') && cellA1.toLowerCase().includes('name');
                const hasC1Label = cellC1.toLowerCase().includes('seller') && cellC1.toLowerCase().includes('id');
                const hasE1Label = cellE1.toLowerCase().includes('buyer') && cellE1.toLowerCase().includes('name');
                const hasG1Label = cellG1.toLowerCase().includes('buyer') && cellG1.toLowerCase().includes('id');

                if (!hasA1Label || !hasC1Label || !hasE1Label || !hasG1Label) {
                    metaErrors.push('1行目にSellerおよびBuyer情報(A1:H1)が正しく設定されていません。最新のテンプレートをご利用ください。');
                } else {
                    if (expectedSellerId && cellD1 !== expectedSellerId) {
                        metaErrors.push(`Seller IDが一致しません。(Excel: 「${cellD1 || '未設定'}」、選択中: 「${expectedSellerId}」)`);
                    }
                    if (expectedSellerName && cellB1 !== expectedSellerName) {
                        metaErrors.push(`Seller Nameが一致しません。(Excel: 「${cellB1 || '未設定'}」、選択中: 「${expectedSellerName}」)`);
                    }
                    if (expectedBuyerId && cellH1 !== expectedBuyerId) {
                        metaErrors.push(`Buyer IDが一致しません。(Excel: 「${cellH1 || '未設定'}」、選択中: 「${expectedBuyerId}」)`);
                    }
                    if (expectedBuyerName && cellF1 !== expectedBuyerName) {
                        metaErrors.push(`Buyer Nameが一致しません。(Excel: 「${cellF1 || '未設定'}」、選択中: 「${expectedBuyerName}」)`);
                    }
                }

                if (metaErrors.length > 0) {
                    setValidationErrors([{ rowNumber: 1, productName: '組織情報検証 (Row 1)', messages: metaErrors }]);
                    setParsing(false);
                    return;
                }

                // Check for duplicate No values inside the uploaded file (starting from row 3)
                const excelNos = new Set();
                const duplicateExcelNos = new Set();
                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber <= 2) return; // Skip row 1 (Seller/Buyer info) and row 2 (Headers)
                    const cell = row.getCell(1); // column 1 is "No"
                    const val = getCellValue(cell);
                    if (val !== null && val !== undefined && val !== '') {
                        const cleanVal = val.toString().replace(/,/g, '');
                        const num = Number(cleanVal);
                        if (!isNaN(num)) {
                            if (excelNos.has(num)) {
                                duplicateExcelNos.add(num);
                            }
                            excelNos.add(num);
                        }
                    }
                });

                // Get existing Nos in the DB to check duplicate against DB
                const existingNos = new Set(
                    (existingItems || [])
                        .map(item => item.No)
                        .filter(no => no !== null && no !== undefined && no !== '')
                        .map(no => Number(no))
                );

                const tempParsed = [];
                const tempErrors = [];

                const DOC_GROUPS = [
                    { name: 'SDS1', fields: ['SDS１ボタン名', 'SDS１ファイル名', 'SDS１タイトル', 'SDS１ふりがな', 'SDS１発行年月日'], fileKey: 'SDS１ファイル名' },
                    { name: '取説1', fields: ['取説１ボタン名', '取説１ファイル名', '取説１タイトル', '取説１ふりがな', '取説１発行年月日'], fileKey: '取説１ファイル名' },
                    { name: '取説2', fields: ['取説２ボタン名', '取説２ファイル名', '取説２タイトル', '取説２ふりがな', '取説２発行年月日'], fileKey: '取説２ファイル名' },
                    { name: 'カタログ1', fields: ['カタログ１ボタン名', 'カタログ１ファイル名', 'カタログ１タイトル', 'カタログ１ふりがな', 'カタログ１発行年月日'], fileKey: 'カタログ１ファイル名' },
                    { name: 'カタログ2', fields: ['カタログ２ボタン名', 'カタログ２ファイル名', 'カタログ２タイトル', 'カタログ２ふりがな', 'カタログ２発行年月日'], fileKey: 'カタログ２ファイル名' },
                    { name: 'カタログ3', fields: ['カタログ３ボタン名', 'カタログ３ファイル名', 'カタログ３タイトル', 'カタログ３ふりがな', 'カタログ３発行年月日'], fileKey: 'カタログ３ファイル名' },
                    { name: '図面1', fields: ['図面１ボタン名', '図面１ファイル名', '図面１タイトル', '図面１ふりがな', '図面１発行年月日'], fileKey: '図面１ファイル名' },
                    { name: '図面2', fields: ['図面２ボタン名', '図面２ファイル名', '図面２タイトル', '図面２ふりがな', '図面２発行年月日'], fileKey: '図面２ファイル名' },
                    { name: '図面3', fields: ['図面３ボタン名', '図面３ファイル名', '図面３タイトル', '図面３ふりがな', '図面３発行年月日'], fileKey: '図面３ファイル名' },
                ];

                const rawRowsList = [];
                const requiredDocSet = new Set();

                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber <= 2) return; // Skip row 1 (Seller/Buyer info) and row 2 (Headers)

                    const rowData = {};
                    const rowErrors = [];

                    COLUMNS.forEach((col, index) => {
                        const cell = row.getCell(index + 1);
                        let val = getCellValue(cell);

                        if (val !== null && val !== undefined && val !== '') {
                            if (col.type === 'number') {
                                const cleanVal = val.toString().replace(/,/g, '');
                                const num = Number(cleanVal);
                                if (isNaN(num)) {
                                    rowErrors.push(`${col.label}: 有効な数値を入力してください。`);
                                } else {
                                    rowData[col.key] = num;
                                }
                            } else if (col.type === 'date') {
                                const formattedDate = formatDateYYYYMMDD(val);
                                if (!formattedDate) {
                                    rowErrors.push(`${col.label}: 日付フォーマットを確認してください (YYYY-MM-DD)。`);
                                } else {
                                    rowData[col.key] = formattedDate;
                                }
                            } else if (col.type === 'tax_rate') {
                                const cleanVal = val.toString().trim().replace(/%/g, '');
                                const num = Number(cleanVal);
                                if (isNaN(num)) {
                                    rowErrors.push(`${col.label}: 消費税率を正しく入力してください。`);
                                } else {
                                    if (num === 0.1 || num === 10) {
                                        rowData[col.key] = 0.1;
                                    } else if (num === 0.08 || num === 8) {
                                        rowData[col.key] = 0.08;
                                    } else if (num === 0) {
                                        rowData[col.key] = 0;
                                    } else {
                                        rowErrors.push(`${col.label}: 消費税率は10%、8%、または0%である必要があります。`);
                                    }
                                }
                            } else if (col.type === 'corporate_number') {
                                const cleanVal = val.toString().trim().replace(/[-\s]/g, '');
                                if (cleanVal.length > 13 || isNaN(Number(cleanVal))) {
                                    rowErrors.push(`${col.label}: 法人番号は最大13桁の数値である必要があります。`);
                                } else {
                                    rowData[col.key] = cleanVal;
                                }
                            } else {
                                rowData[col.key] = val.toString().trim();
                            }
                        } else {
                            rowData[col.key] = null;
                        }

                        if (col.required && (rowData[col.key] === null || rowData[col.key] === '')) {
                            rowErrors.push(`${col.label}は必須項目です。`);
                        }
                    });

                    // Validate No uniqueness
                    const noVal = rowData['No'];
                    if (noVal !== null && noVal !== undefined && noVal !== '') {
                        const num = Number(noVal);
                        if (existingNos.has(num)) {
                            rowErrors.push(`No: 「${num}」はすでにデータベースで使用されています。`);
                        }
                        if (duplicateExcelNos.has(num)) {
                            rowErrors.push(`No: 「${num}」はExcelファイル内で重複しています。`);
                        }
                    }

                    // Relational category verification
                    const hasCategoryFieldErrors = rowErrors.some(err => err.includes('大分類') || err.includes('中分類') || err.includes('小分類'));
                    if (!hasCategoryFieldErrors) {
                        const majorCode = rowData['大分類'];
                        const middleCode = rowData['中分類'];
                        const smallCode = rowData['小分類'];

                        const majorItem = treeData.find(item => item.level === 'major' && item.code === majorCode);
                        if (!majorItem) {
                            rowErrors.push(`大分類: カテゴリコード「${majorCode}」が見つかりませんでした。`);
                        } else {
                            const middleItem = treeData.find(item => item.level === 'middle' && item.code === middleCode && item.categoryId === majorItem.ID);
                            if (!middleItem) {
                                rowErrors.push(`中分類: カテゴリコード「${middleCode}」が見つからないか、大分類「${majorCode}」に属していません。`);
                            } else {
                                const smallItem = treeData.find(item => item.level === 'small' && item.code === smallCode && item.categoryId === middleItem.ID);
                                if (!smallItem) {
                                    rowErrors.push(`小分類: カテゴリコード「${smallCode}」が見つからないか、中分類「${middleCode}」に属していません。`);
                                }
                            }
                        }
                    }

                    // Document group completeness & file extension validation
                    DOC_GROUPS.forEach(group => {
                        const filledFields = group.fields.filter(key => {
                            const val = rowData[key];
                            return val !== null && val !== undefined && String(val).trim() !== '';
                        });

                        if (filledFields.length > 0 && filledFields.length < group.fields.length) {
                            const missingFields = group.fields.filter(key => {
                                const val = rowData[key];
                                return val === null || val === undefined || String(val).trim() === '';
                            });
                            rowErrors.push(`${group.name}: ${group.fields.join('、')} のすべての項目を入力してください。(未入力: ${missingFields.join('、')})`);
                        }

                        const fileName = rowData[group.fileKey] ? String(rowData[group.fileKey]).trim() : '';
                        if (fileName) {
                            if (group.isImage) {
                                if (!/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(fileName)) {
                                    rowErrors.push(`${group.fileKey}: 有効な画像ファイル拡張子（.png, .jpg等）を含めて入力してください。(入力値: 「${fileName}」)`);
                                } else {
                                    const clean = fileName.split('/').pop().split('\\').pop();
                                    requiredDocSet.add(clean);
                                }
                            } else {
                                if (!/\.[a-zA-Z0-9]+$/i.test(fileName)) {
                                    rowErrors.push(`${group.fileKey}: 有効なファイル拡張子（.pdf等）を含めて入力してください。(入力値: 「${fileName}」)`);
                                } else {
                                    const clean = fileName.split('/').pop().split('\\').pop();
                                    requiredDocSet.add(clean);
                                }
                            }
                        }
                    });

                    // Image group completeness & extension validation (画像1, 画像2, 画像3)
                    IMAGE_GROUPS.forEach(group => {
                        const filledFields = group.fields.filter(key => {
                            const val = rowData[key];
                            return val !== null && val !== undefined && String(val).trim() !== '';
                        });

                        if (filledFields.length > 0 && filledFields.length < group.fields.length) {
                            const missingFields = group.fields.filter(key => {
                                const val = rowData[key];
                                return val === null || val === undefined || String(val).trim() === '';
                            });
                            rowErrors.push(`${group.name}: ${group.fields.join('、')} のすべての項目を入力してください。(未入力: ${missingFields.join('、')})`);
                        }

                        const fileName = rowData[group.fileKey] ? String(rowData[group.fileKey]).trim() : '';
                        if (fileName) {
                            if (!/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(fileName)) {
                                rowErrors.push(`${group.fileKey}: 有効な画像ファイル拡張子（.png, .jpg等）を含めて入力してください。(入力値: 「${fileName}」)`);
                            } else {
                                const clean = fileName.split('/').pop().split('\\').pop();
                                requiredDocSet.add(clean);
                            }
                        }
                    });

                    rawRowsList.push({
                        rowNumber,
                        rowData,
                        baseErrors: rowErrors
                    });
                });

                setRawExcelRows(rawRowsList);
                setRequiredDocFiles(Array.from(requiredDocSet));
                validateParsedRows(rawRowsList, attachedFileList);
            } catch (err) {
                console.error(err);
                message.error('ファイルの読み込み中にエラーが発生しました: ' + err.message);
            } finally {
                setParsing(false);
            }
        };
        reader.readAsArrayBuffer(targetFile);
        return false;
    };

    const handleImport = async () => {
        setImporting(true);
        setProgress(0);

        const writeRef = getWriteRef();
        if (!writeRef) {
            message.error('保存先コレクションパスが見つかりませんでした。');
            setImporting(false);
            return;
        }

        try {
            const total = parsedRows.length;
            const chunkSize = 400; // Batch limits
            let successCount = 0;

            const nowStr = formatDateYYYYMMDD(new Date());
            const buyerOrgId = getOrgId(effectiveBuyerOrg) || 'default';
            const db = firebase.firestore();

            const fileMap = new Map();
            [...(fileList || []), ...(attachedFileList || [])].forEach(f => {
                const rawFile = f.originFileObj || f;
                if (rawFile && rawFile.name) {
                    const fullName = rawFile.name.trim().toLowerCase();
                    const baseName = fullName.split('/').pop().split('\\').pop().toLowerCase();
                    fileMap.set(fullName, rawFile);
                    fileMap.set(baseName, rawFile);
                }
            });



            for (let i = 0; i < total; i += chunkSize) {
                const chunk = parsedRows.slice(i, i + chunkSize);
                const batch = firebase.firestore().batch();

                for (const row of chunk) {
                    const docRef = writeRef.doc();
                    const raw = row.data;

                    // Process attached files for this row
                    const rowFiles = [];
                    const rowFileNames = [];

                    for (const group of DOC_GROUPS) {
                        let rawFileName = raw[group.fileKey];
                        const buttonName = raw[group.nameKey] || rawFileName;

                        if (rawFileName) {
                            rawFileName = String(rawFileName).trim();
                            let cleanFileName = rawFileName;
                            if (rawFileName.startsWith('http://') || rawFileName.startsWith('https://')) {
                                try {
                                    const urlObj = new URL(rawFileName);
                                    cleanFileName = urlObj.pathname.split('/').pop() || rawFileName;
                                } catch (e) {
                                    cleanFileName = rawFileName.split('/').pop() || rawFileName;
                                }
                            } else {
                                cleanFileName = rawFileName.split('/').pop().split('\\').pop() || rawFileName;
                            }

                            const storagePath = `${group.prefix}/${buyerOrgId}/${cleanFileName}`;
                            let uploadedFileObj = fileMap.get(cleanFileName.toLowerCase());
                            let mimeType = group.isImage ? 'image/png' : 'application/pdf';

                            if (uploadedFileObj && uploadedFileObj.type) {
                                mimeType = uploadedFileObj.type;
                            }

                            // Auto-fetch file via URL ONLY if rawFileName is a valid HTTP/HTTPS URL
                            if (!uploadedFileObj && firebase.storage && (rawFileName.startsWith('http://') || rawFileName.startsWith('https://'))) {
                                try {
                                    const res = await fetch(rawFileName);
                                    const contentType = res.headers.get('content-type') || '';
                                    // Ensure response is OK and NOT an HTML fallback error page
                                    if (res.ok && !contentType.toLowerCase().includes('html')) {
                                        const blob = await res.blob();
                                        if (blob && blob.size > 0) {
                                            uploadedFileObj = blob;
                                            mimeType = contentType || 'application/pdf';
                                        }
                                    }
                                } catch (fetchErr) {
                                    console.warn('Auto fetch file error for URL:', rawFileName, fetchErr);
                                }
                            }

                            // Only upload to Firebase Storage if a VALID non-HTML Blob/File object exists
                            if (uploadedFileObj && firebase.storage) {
                                try {
                                    const storageRef = firebase.storage().ref().child(storagePath);
                                    const metadata = { contentType: mimeType || 'application/pdf' };
                                    await storageRef.put(uploadedFileObj, metadata);
                                    console.log(`Successfully uploaded ${cleanFileName} (${uploadedFileObj.size || 0} bytes, ${mimeType}) to ${storagePath}`);
                                } catch (stErr) {
                                    console.warn('Storage upload error for file:', cleanFileName, stErr);
                                }
                            }

                            // Create document in Firestore 'files' collection
                            const fileDocRef = db.collection('files').doc();
                            await fileDocRef.set({
                                file: storagePath,
                                name: buttonName
                            });

                            rowFiles.push({
                                file: fileDocRef.id,
                                name: buttonName
                            });
                            rowFileNames.push(buttonName);
                        }
                    }

                    // Process IMAGE_GROUPS (画像1, 画像2, 画像3 -> image, image2, image3)
                    const bucketName = (firebase.app().options && firebase.app().options.storageBucket);
                    const imageFields = {};

                    for (const imgGroup of IMAGE_GROUPS) {
                        let rawFileName = raw[imgGroup.fileKey];
                        if (rawFileName) {
                            rawFileName = String(rawFileName).trim();
                            let cleanFileName = rawFileName;
                            if (rawFileName.startsWith('http://') || rawFileName.startsWith('https://')) {
                                try {
                                    const urlObj = new URL(rawFileName);
                                    cleanFileName = urlObj.pathname.split('/').pop() || rawFileName;
                                } catch (e) {
                                    cleanFileName = rawFileName.split('/').pop() || rawFileName;
                                }
                            } else {
                                cleanFileName = rawFileName.split('/').pop().split('\\').pop() || rawFileName;
                            }

                            const storagePath = `items/${buyerOrgId}/${cleanFileName}`;
                            const gsUri = `gs://${bucketName}/${storagePath}`;
                            let uploadedFileObj = fileMap.get(cleanFileName.toLowerCase());
                            let mimeType = 'image/png';

                            if (uploadedFileObj && uploadedFileObj.type) {
                                mimeType = uploadedFileObj.type;
                            }

                            if (!uploadedFileObj && firebase.storage && (rawFileName.startsWith('http://') || rawFileName.startsWith('https://'))) {
                                try {
                                    const res = await fetch(rawFileName);
                                    const contentType = res.headers.get('content-type') || '';
                                    if (res.ok && !contentType.toLowerCase().includes('html')) {
                                        const blob = await res.blob();
                                        if (blob && blob.size > 0) {
                                            uploadedFileObj = blob;
                                            mimeType = contentType || mimeType;
                                        }
                                    }
                                } catch (fetchErr) {
                                    console.warn('Auto fetch image error for URL:', rawFileName, fetchErr);
                                }
                            }

                            if (uploadedFileObj && firebase.storage) {
                                try {
                                    const storageRef = firebase.storage().ref().child(storagePath);
                                    const metadata = { contentType: mimeType };
                                    await storageRef.put(uploadedFileObj, metadata);
                                    console.log(`Successfully uploaded image ${cleanFileName} (${uploadedFileObj.size || 0} bytes) to ${storagePath}`);
                                } catch (stErr) {
                                    console.warn('Storage upload error for image:', cleanFileName, stErr);
                                }
                            }

                            imageFields[imgGroup.dbKey] = gsUri;
                        } else {
                            imageFields[imgGroup.dbKey] = null;
                        }
                    }

                    // Map fields to DB format
                    const nowTs = firebase.firestore.Timestamp.now();
                    const payload = {
                        No: raw.No,
                        '仕入先（本社）': raw['仕入先（本社）'],
                        仕入先法人番号: raw['仕入先法人番号'] || null,
                        仕入先事業所名: raw['仕入先事業所名'],
                        仕入先事業所コード: raw['仕入先事業所コード'] || null,
                        P4CLOUD仕入先コード: raw['P4CLOUD仕入先コード'] || null,
                        仕入先EDIコード商品コード: raw['仕入先EDIコード商品コード'] || null,
                        仕入先発注コード: raw['仕入先発注コード'] || null,
                        正式メーカー名: raw['正式メーカー名'],
                        メーカー法人番号: raw['メーカー法人番号'] || null,
                        販売企業商品コード: raw['販売企業商品コード'] || null,
                        正式メーカー商品名: raw['正式メーカー商品名'],
                        正式メーカー商品名かな: raw['正式メーカー商品名かな'] || null,
                        P4CLOUD商品コード: raw['P4CLOUD商品コード'] || null,
                        P4CLOUD商品名: raw['P4CLOUD商品名'],
                        P4CLOUD商品名ふりがな: raw['P4CLOUD商品名ふりがな'] || null,
                        '容量・入数': raw['容量・入数'],
                        発注数量: raw['発注数量'],
                        単位: raw['単位'],
                        発注数: raw['発注数'],
                        発注単位: raw['発注単位'],
                        荷姿名称１: raw['荷姿名称１'],
                        劇毒物区分名: raw['劇毒物区分名'] || null,
                        危険物区分名: raw['危険物区分名'] || null,
                        消費税率: Number(raw['消費税率']),
                        大分類: raw['大分類'],
                        中分類: raw['中分類'],
                        小分類: raw['小分類'],
                        売価: Number(raw['売価']),
                        売単価: raw['売単価'] !== undefined && raw['売単価'] !== null ? Number(raw['売単価']) : null,
                        archive: false,
                        files: rowFiles,
                        files_names: rowFileNames,
                        image: imageFields.image || null,
                        image2: imageFields.image2 || null,
                        image3: imageFields.image3 || null,
                        P4CLOUD登録日: toFirestoreTimestamp(raw['P4CLOUD登録日']) || nowTs,
                        新規登録依頼日: toFirestoreTimestamp(raw['新規登録依頼日']) || nowTs,
                        updatedAt: nowTs
                    };

                    // Specification title/value pairs (表題１/値１ ~ 表題２０/値２０)
                    const specArray = [];
                    for (let specIdx = 1; specIdx <= 20; specIdx++) {
                        const t = raw[`表題${specIdx}`];
                        const v = raw[`値${specIdx}`];
                        if (t || v) {
                            specArray.push({ title: t || '', value: v || '' });
                        }
                    }
                    payload.data = specArray;

                    // Handle price structure
                    const defaultExpTs = toFirestoreTimestamp('2099-12-01');
                    if (raw.priceAmount !== undefined && raw.priceAmount !== null) {
                        payload.price = [
                            {
                                price: Number(raw.priceAmount),
                                expiration_date: toFirestoreTimestamp(raw.expirationDate) || defaultExpTs
                            }
                        ];
                    } else if (raw['売価'] !== undefined && raw['売価'] !== null) {
                        payload.price = [
                            {
                                price: Number(raw['売価']),
                                expiration_date: toFirestoreTimestamp(raw.expirationDate) || defaultExpTs
                            }
                        ];
                    } else {
                        payload.price = null;
                    }

                    // Copy only non-excluded column fields into payload so no duplicate flat fields are saved
                    COLUMNS.forEach(col => {
                        if (!EXCLUDE_TOP_LEVEL_KEYS.has(col.key)) {
                            if (payload[col.key] === undefined && raw[col.key] !== undefined && raw[col.key] !== null) {
                                if (col.type === 'date') {
                                    payload[col.key] = toFirestoreTimestamp(raw[col.key]);
                                } else {
                                    payload[col.key] = raw[col.key];
                                }
                            }
                        }
                    });

                    batch.set(docRef, payload);
                }

                await batch.commit();
                successCount += chunk.length;
                setProgress(Math.round((successCount / total) * 100));
            }

            message.success(`計 ${successCount} 件の商品を正常にインポートしました。`);
            setModalOpen(false);
            setFileList([]);
            setParsedRows([]);
            setValidationErrors([]);
            if (onSuccessRefresh) {
                onSuccessRefresh();
            }
        } catch (err) {
            console.error('Import error:', err);
            message.error('インポート中にエラーが発生しました: ' + err.message);
        } finally {
            setImporting(false);
        }
    };

    const errorColumns = [
        {
            title: '行',
            dataIndex: 'rowNumber',
            key: 'rowNumber',
            width: 80
        },
        {
            title: '商品名',
            dataIndex: 'productName',
            key: 'productName',
            width: 200,
            ellipsis: true
        },
        {
            title: 'エラー内容',
            dataIndex: 'messages',
            key: 'messages',
            render: (messages) => (
                <ul style={{ margin: 0, paddingLeft: 16, color: '#ff4d4f' }}>
                    {messages.map((msg, i) => (
                        <li key={i}>{msg}</li>
                    ))}
                </ul>
            )
        }
    ];

    return (
        <>
            <Button
                type="primary"
                icon={<FileExcelOutlined />}
                onClick={() => setModalOpen(true)}
                style={{
                    backgroundColor: '#1E4620',
                    borderColor: '#1E4620',
                    color: '#fff',
                    borderRadius: 4,
                    height: 38,
                    marginLeft: 10,
                    fontWeight: 500,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                Excelからインポート
            </Button>

            <Modal
                title={
                    <Title level={4} style={{ margin: 0 }}>
                        <FileExcelOutlined style={{ color: '#52c41a', marginRight: 8 }} />
                        商品Excel一括登録
                    </Title>
                }
                open={modalOpen}
                onCancel={() => {
                    if (!importing) {
                        setModalOpen(false);
                        setFileList([]);
                        setParsedRows([]);
                        setValidationErrors([]);
                    }
                }}
                footer={[
                    <Button key="cancel" onClick={() => setModalOpen(false)} disabled={importing}>
                        閉じる
                    </Button>,
                    <Button
                        key="import"
                        type="primary"
                        onClick={handleImport}
                        loading={importing}
                        disabled={parsedRows.length === 0 || validationErrors.length > 0}
                        style={{ backgroundColor: '#1890ff' }}
                    >
                        インポート ({parsedRows.length})
                    </Button>
                ]}
                width={850}
                destroyOnClose
            >
                <div style={{ padding: '8px 0' }}>
                    <Paragraph>
                        一括登録する商品のリストについて、対応するテンプレートExcelファイルをダウンロードして作成し、アップロードしてください。
                    </Paragraph>

                    <Button
                        type="dashed"
                        icon={<DownloadOutlined />}
                        onClick={downloadTemplate}
                        style={{ marginBottom: 16 }}
                    >
                        テンプレートExcelダウンロード
                    </Button>

                    <Card size="small" title="1. Excelファイルの選択 (.xlsx)" style={{ marginBottom: 16 }}>
                        <Upload
                            accept=".xlsx, .xls"
                            beforeUpload={(file, fileListArg) => {
                                handleFileRead(file, fileListArg);
                                return false;
                            }}
                            fileList={fileList}
                            onChange={({ fileList: fl }) => setFileList(fl.slice(-1))}
                            maxCount={1}
                        >
                            <Button icon={<UploadOutlined />} loading={parsing}>
                                Excelファイルを選択 (.xlsx)
                            </Button>
                        </Upload>
                    </Card>

                    {requiredDocFiles.length > 0 && (
                        <Card size="small" title={`2. 添付PDFファイルの検証・追加 (${requiredDocFiles.length}件のファイル指定)`} style={{ marginBottom: 16 }}>
                            <Paragraph type="secondary" style={{ fontSize: 13, marginBottom: 8 }}>
                                Excel内で指定された以下のファイルを追加添付してください。すべてのファイルが確認されると検証が成功します。
                            </Paragraph>

                            <div style={{ marginBottom: 12, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                {requiredDocFiles.map((fileName, idx) => {
                                    const isUploaded = (attachedFileList || []).some(f => {
                                        const name = (f.originFileObj?.name || f.name || '').trim().split('/').pop().split('\\').pop().toLowerCase();
                                        return name === fileName.toLowerCase();
                                    });
                                    return (
                                        <Tag
                                            key={idx}
                                            color={isUploaded ? 'success' : 'error'}
                                            icon={isUploaded ? <CheckCircleOutlined /> : <ExclamationCircleOutlined />}
                                            style={{ padding: '4px 8px', fontSize: 13 }}
                                        >
                                            {fileName} {isUploaded ? '(確認済)' : '(未選択)'}
                                        </Tag>
                                    );
                                })}
                            </div>

                            <Upload
                                accept=".pdf, .doc, .docx, .png, .jpg, .jpeg"
                                multiple={true}
                                beforeUpload={() => false}
                                fileList={attachedFileList}
                                onChange={({ fileList: newFileList }) => handleAttachmentChange(newFileList)}
                            >
                                <Button icon={<UploadOutlined />}>
                                    添付PDFファイルを選択・追加
                                </Button>
                            </Upload>
                        </Card>
                    )}

                    {parsing && (
                        <div style={{ textAlign: 'center', padding: 20 }}>
                            <Progress percent={50} status="active" showInfo={false} />
                            <Text type="secondary" style={{ marginTop: 8, display: 'block' }}>ファイルを検証中...</Text>
                        </div>
                    )}

                    {importing && (
                        <div style={{ margin: '16px 0' }}>
                            <Text strong>データを保存中:</Text>
                            <Progress percent={progress} status="active" />
                        </div>
                    )}

                    {!parsing && fileList.length > 0 && (
                        <div style={{ marginTop: 20 }}>
                            {validationErrors.length === 0 && parsedRows.length > 0 ? (
                                <Alert
                                    message={
                                        <Space>
                                            <CheckCircleOutlined style={{ color: '#52c41a' }} />
                                            <Text strong style={{ color: '#389e0d' }}>検証が成功しました！</Text>
                                        </Space>
                                    }
                                    description={`計 ${parsedRows.length} 行のデータを正常に読み込みました。「インポート」ボタンをクリックして保存してください。`}
                                    type="success"
                                    showIcon={false}
                                />
                            ) : null}

                            {validationErrors.length > 0 ? (
                                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                                    <Alert
                                        message={
                                            <Space>
                                                <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
                                                <Text strong style={{ color: '#cf1322' }}>データの検証に失敗しました</Text>
                                            </Space>
                                        }
                                        description={`計 ${validationErrors.length} 行のデータにエラーが検出されました。エラーを修正してファイルを再アップロードしてください。`}
                                        type="error"
                                        showIcon={false}
                                    />
                                    <Table
                                        columns={errorColumns}
                                        dataSource={validationErrors}
                                        rowKey="rowNumber"
                                        pagination={{ pageSize: 5 }}
                                        size="small"
                                        bordered
                                    />
                                </Space>
                            ) : null}
                        </div>
                    )}
                </div>
            </Modal>
        </>
    );
};

export default ProductExcelImport;
